// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__38pPU","footer":"ModalInfo_footer__2Bc-O"};